"use client"

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { History } from "lucide-react"
import { useVisualizer } from "@/lib/visualizer-context"

export function SchemaHistoryDropdown() {
  const { schemaHistory, loadSchemaFromHistory } = useVisualizer()

  const handleValueChange = (value: string) => {
    const index = Number.parseInt(value, 10)
    if (!isNaN(index)) {
      loadSchemaFromHistory(index)
    }
  }

  const formatDate = (timestamp: number) => {
    return new Date(timestamp).toLocaleString()
  }

  if (schemaHistory.length === 0) {
    return null
  }

  return (
    <Select onValueChange={handleValueChange}>
      <SelectTrigger className="w-[200px]">
        <History className="h-4 w-4 mr-2" />
        <SelectValue placeholder="schema history" />
      </SelectTrigger>
      <SelectContent>
        {schemaHistory.map((entry, index) => (
          <SelectItem key={index} value={index.toString()}>
            <div className="flex flex-col">
              <span className="font-medium">{entry.label || `Schema ${index + 1}`}</span>
              <span className="text-xs text-muted-foreground">
                <div>{formatDate(entry.timestamp)}</div> <div>{Object.keys(entry.schema.properties || {}).length} properties</div>
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

